import { store } from '@/store';
import { setExternalLookupOptions } from '@/store/slices';
import {
  adaptFieldsGroupRestrictionResponse,
  adaptFormFieldExternalLookupResponseToExternalLookupOptions,
  stampGuardedFieldError,
} from '../utilities';
import { adaptFormItemResponseToFormFields } from '../core';
import { IFormBase, StagedFieldsGroupFormField } from '@/forms/typings';
import { StagedFieldsGroupFormFieldBuilder } from '@/forms/builders';
import { FormStagedFieldsGroupResponseDTO } from '@/api/base/DTOs';

export const adaptFormStagedFieldsGroupResponseToStagedFieldsGroupFormField = (
  formStagedFieldsGroupResponse: FormStagedFieldsGroupResponseDTO,
  parentFieldId?: IFormBase['fieldId'],
): StagedFieldsGroupFormField => {
  if (formStagedFieldsGroupResponse.nextStageLookupType !== undefined) {
    store.dispatch(
      setExternalLookupOptions({
        fieldName: formStagedFieldsGroupResponse.fieldID,
        options: adaptFormFieldExternalLookupResponseToExternalLookupOptions(
          formStagedFieldsGroupResponse.nextStageLookupType,
        ),
      }),
    );
  }

  let stagedFieldsGroupFormField = new StagedFieldsGroupFormFieldBuilder()
    .fieldId(formStagedFieldsGroupResponse.fieldID)
    .name(formStagedFieldsGroupResponse.fieldID)
    .title(formStagedFieldsGroupResponse.title)
    .isRequired(formStagedFieldsGroupResponse.isRequired)
    .hasAnyValue(formStagedFieldsGroupResponse.hasAnyValue)
    .maxItems(formStagedFieldsGroupResponse.maxGroupCount)
    .minItems(formStagedFieldsGroupResponse.minGroupCount)
    .index(formStagedFieldsGroupResponse.index)
    .questionIfOptional(formStagedFieldsGroupResponse.questionIfOptional)
    .titleWhenFilled(formStagedFieldsGroupResponse.titleWhenFilled)
    .hintWhenFilled(formStagedFieldsGroupResponse.hintWhenFilled)
    .notApplicable(formStagedFieldsGroupResponse.notApplicable)
    .showNotApplicable(formStagedFieldsGroupResponse.showNotApplicable)
    .allowRemove(formStagedFieldsGroupResponse.allowRemove)
    .firstStageFields(
      formStagedFieldsGroupResponse.firstStageFields.map(child =>
        adaptFormItemResponseToFormFields(
          child,
          formStagedFieldsGroupResponse.fieldID,
        ),
      ),
    )
    .otherFields(
      formStagedFieldsGroupResponse.otherFields.map(child =>
        adaptFormItemResponseToFormFields(
          child,
          formStagedFieldsGroupResponse.fieldID,
        ),
      ),
    )
    .parentFieldId(parentFieldId);

  if (formStagedFieldsGroupResponse.hint) {
    stagedFieldsGroupFormField = stagedFieldsGroupFormField.hint(
      formStagedFieldsGroupResponse.hint,
    );
  }

  if (formStagedFieldsGroupResponse.hintImageUrl) {
    stagedFieldsGroupFormField = stagedFieldsGroupFormField.hintImageUrl(
      formStagedFieldsGroupResponse.hintImageUrl,
    );
  }

  const restriction = adaptFieldsGroupRestrictionResponse(
    formStagedFieldsGroupResponse.restriction,
  );
  if (restriction) {
    stagedFieldsGroupFormField = stagedFieldsGroupFormField.restriction(
      restriction,
    );
  }

  return stampGuardedFieldError(stagedFieldsGroupFormField.build());
};
